import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeSideDrawer } from 'actions/SideDrawerActions';
import { getSideDrawerContent } from 'selectors/sideDrawerSelectors';

const SideDrawerRoot: React.FC = () => {
  const dispatch = useDispatch();
  const ContentComponent = useSelector(getSideDrawerContent);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!ContentComponent) return;
    setTimeout(() => setIsOpen(true), 500);
  }, [ContentComponent]);

  const closeDrawer = useCallback(() => {
    setIsOpen(false);
    setTimeout(() => dispatch(closeSideDrawer()), 500);
  }, [dispatch]);

  return ContentComponent ? <ContentComponent isOpen={isOpen} closeDrawer={closeDrawer} /> : null;
};

export default SideDrawerRoot;
